"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = {
  $schema: '../assetlist.schema.json',
  chain_name: 'archwaytestnet',
  assets: [{
    description: 'The native token of Archway testnetwork',
    denom_units: [{
      denom: 'aconst',
      exponent: 0
    }, {
      denom: 'uconst',
      exponent: 12
    }, {
      denom: 'const',
      exponent: 18
    }],
    base: 'aconst',
    name: 'Archway',
    display: 'const',
    symbol: 'CONST'
  }]
};
var _default = exports["default"] = info;